import { render, staticRenderFns } from "./extension-activity.vue?vue&type=template&id=2cde2e91&"
import script from "./extension-activity.vue?vue&type=script&lang=js&"
export * from "./extension-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports